import { createContext } from 'react';

import type { DownloadPreparationManagerMethods } from './hooks/useDownloadPreparationManager';

export const DownloadPreparationContext = createContext<DownloadPreparationManagerMethods>({
  startDownloadPreparation: () => {},
  stopDownloadPreparation: () => {},
  getIsPreparingDownload: () => false,
  status: 'ready',
  internalApiUrl: '',
});
